import { useEffect, useState } from "react";
import { API_BASE } from "../../../config/config";

export default function useAuthUser() {
  const [state, setState] = useState({ loading: true, user: null, error: null });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${API_BASE}/api/me`, { credentials: "include", cache: "no-store" });
        if (!res.ok) {
          if (!cancelled) setState({ loading: false, user: null, error: null });
          return;
        }
        const data = await res.json(); // { user, isAuthenticated }
        if (!cancelled) setState({ loading: false, user: data && data.user ? data.user : null, error: null });
      } catch (err) {
        if (!cancelled) setState({ loading: false, user: null, error: err });
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return state;
}
